import React from 'react';
import { FileCopy, List } from '@material-ui/icons';
import { Chip, IconButton, TableCell, TableRow } from '@material-ui/core';

import { IGeneratedDevice, IGroupedDevices } from '../../views/PxwProcessDevices/types';

const CHIP_COLOR: Record<string, 'default' | 'primary' | 'secondary' | undefined> = {
  Match: 'primary',
  'Mismatch - Functional': 'default',
  'Mismatch - Non-Functional': 'secondary',
};

interface IDeviceCategoryRowProps {
  cat: IGeneratedDevice['testCategory'];
  group: IGroupedDevices[IGeneratedDevice['testCategory']];
  isCopied: boolean;
  onCopyAll: () => void;
  onOpenPopover: (e: React.MouseEvent<HTMLElement>) => void;
}

const DeviceCategoryRow: React.FC<IDeviceCategoryRowProps> = ({
  cat,
  group,
  isCopied,
  onCopyAll,
  onOpenPopover,
}) => {
  const serialsText = group.serialItems.map((d) => d.serialId).join(', ');
  return (
    <TableRow>
      <TableCell>
        <Chip label={cat} color={CHIP_COLOR[cat]} size="small" />
      </TableCell>
      <TableCell>{group.totalCount}</TableCell>
      <TableCell>{group.autoGeneratedCount}</TableCell>
      <TableCell>{group.preExistingCount}</TableCell>
      <TableCell>
        <div className="pxw-process-devices__serial-cell" title={serialsText}>
          {serialsText}
        </div>
      </TableCell>
      <TableCell padding="none">
        <IconButton
          size="small"
          title={isCopied ? 'Copied!' : 'Copy all serial numbers'}
          onClick={onCopyAll}>
          <FileCopy fontSize="small" />
        </IconButton>
      </TableCell>
      <TableCell padding="none">
        <IconButton size="small" title="View and search serial numbers" onClick={onOpenPopover}>
          <List fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default DeviceCategoryRow;
